import { render } from "./Bloqueios.vue?vue&type=template&id=13a9e4d2&scoped=true"
import script from "./Bloqueios.vue?vue&type=script&lang=js"
export * from "./Bloqueios.vue?vue&type=script&lang=js"

import "./Bloqueios.vue?vue&type=style&index=0&id=13a9e4d2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a9e4d2"]])

export default __exports__